// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__x3LIE","header":"styles_header__OyE8C","body":"styles_body__eNhaP"};